// extracted by mini-css-extract-plugin
module.exports = {"l3-category":"l3-category_l3-category__Ink2p"};